<template>
  <div v-if="loading" class="loader-container"><Loader /></div>
  <div v-else>
    <div v-if="blogDetail" class="detail-page">
      <DetailBanner
        :v-if="blogDetail"
        :featuredImage="blogDetail.featuredImage"
        :featuredImageAltText="blogDetail.featuredImageAltText"
        :title="blogDetail.title"
        :tags="blogDetail.tags"
        :publishedDate="blogDetail.date"
        :maxReadTime="blogDetail.maxReadTime"
        :slug="blogDetail.slug"
        :duration="blogDetail.duration"
        :language="blogDetail.language"
      />
      <div class="blog-body">
        <div class="v-container body-container">
          <BlogDetailBody
            :body="blogDetail.description"
            :title="blogDetail.title"
            :id="blogDetail.id"
            :slug="blogDetail.slug"
            :metaDescription="blogDetail.metaDescription"
            :tags="blogDetail.tags"
            :featured-experts="blogDetail.featuredExperts || []"
          />
        </div>
      </div>
      <RelatedBlogs
        :relatedBlogs="relatedLearninghubs"
        :currentBlogTags="blogDetail.tags || []"
        :routePath="'/learning-hub'"
        v-if="relatedLearninghubs && relatedLearninghubs.length > 0"
      />

      <GetInTouch :buttonName="buttonName" background-color="#DEF3FF" />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute, onBeforeRouteUpdate } from 'vue-router';
import DetailBanner from './DetailBanner.vue';
import BlogDetailBody from './DetailBody.vue';
import RelatedBlogs from '../partials/DetailRelatedBlogs.vue';

import GetInTouch from './../../service/components/GetInTouch.vue';
import Loader from '@/components/Loader.vue';
import learninghubService from '@/services/API/learninghubService.js';

window.scrollTo(0, 0);
const buttonName = 'Connect with us'
const route = useRoute();
const blogId = route.params.id;

const blogDetail = ref(null);
const relatedLearninghubs = ref([]);
const loading = ref(true);
document.getElementById('loaderSection').classList.add('d-none');

const fetchBlog = async (blogId) => {
  try {
    loading.value = true;
    const response = await learninghubService.showLearninghubDetail(blogId);
    if (response.status === 200) {
        blogDetail.value = response.data;
        console.log('Blog Details', blogDetail.value);
        console.log('Featured Experts:', blogDetail.value.featuredExperts);
        relatedLearninghubs.value = response.data.relatedLearningHubs;
        console.log("related blog: ", relatedLearninghubs.value);

    } else {
      throw new Error('Failed to fetch blog details');
    }
  } catch (error) {
    console.error('Error fetching blog:', error);
    relatedBlogs.value = [];
  } finally {
    loading.value = false;
  }
};

onMounted(async () => {
  await fetchBlog(blogId);
});

onBeforeRouteUpdate((to, from, next) => {
  if (to.path !== from.path) {
    window.scrollTo(0, 0);
    loading.value = true;
    const blogId = to.params.id;
    fetchBlog(blogId);
  }
  next();
});
</script>

<style scoped>
.banner-body {
  background-color: var(--light-1);
}
.body-container {
  max-width: 1280px;
}
.blog-body {
  text-align: left;
  background-color: #f7f8fc;
}
.detail-page{
  background-color: #F7F8FC;
}
</style>